import { createContext, Dispatch, SetStateAction } from "react";

import { FormInstance } from "antd";

import { GenerateNewPreliquidationServiceResponse, GetSummaryQuotesServiceResponse, LOADING_SAVED_PRELIQUIDATIONS_STATES } from "../../interfaces";
import { ListQuotaItemDetail } from "../../../Steps/StepTwo/interfaces";

interface GenericDataFormContextProps {

  /** Generic state of is loading */
  canShowSpinner:                 boolean;
  setCanShowSpinner:              Dispatch<SetStateAction<boolean>>;

  /** Flag to show Confimation component */
  canShowConfirmIssue:            boolean;
  setCanShowConfirmIssue:         Dispatch<SetStateAction<boolean>>;

  /** Current step of Preliquidation Proccess */
  currentStep:                    number;
  setCurrentStep:                 Dispatch<SetStateAction<number>>;
  
  /** Info of type of Preliquidation */
  preliquidationInfo?:            GenerateNewPreliquidationServiceResponse | undefined;
  setPreliquidationInfo:          Dispatch<SetStateAction< GenerateNewPreliquidationServiceResponse | undefined>>;
  
  /** Info of type of Preliquidation */
  preliquidationInitialForm:      FormInstance<{ hasAutomaticDebit: string }> | undefined;

  /** Info of total of Preliquidation */
  preliquidationTotalValue:       string;
  setPreliquidationTotalValue:    Dispatch<SetStateAction<string>>; 

  loadingSavedPreliquidation:     boolean;
  setLoadingSavedPreliquidation:  Dispatch<SetStateAction<boolean>>;

  selectedQuotas:                 GetSummaryQuotesServiceResponse | undefined;
  setSelectedQuotas:              Dispatch<SetStateAction<GetSummaryQuotesServiceResponse | undefined>>;

  loadPreliquidationState:        LOADING_SAVED_PRELIQUIDATIONS_STATES | undefined;
  setLoadPreliquidationState:     Dispatch<SetStateAction<LOADING_SAVED_PRELIQUIDATIONS_STATES | undefined>>;

  listQuota:                      Array<ListQuotaItemDetail> | undefined;

  getListOfSelectedQuotas:        () => Promise<void>;
}  

export const GenericDataFormContext = createContext({} as GenericDataFormContextProps);